module.exports = __webpack_public_path__ + "img/news_brief.d581bfc4.png";